const graduateOptionItems = [
  {text: '졸업', value: '졸업'},
  {text: '졸업예정', value: '졸업예정'},
];

const hopeAreaOptionItems = [
  {text: '렌즈 전문점', value: '렌즈 전문점'},
  {text: '아이웨어샵(렌즈&안경)', value: '아이웨어샵(렌즈&안경)'},
];

const hopePathOptionItems = [
  {text: '점장', value: '점장'},
  {text: '가맹점 오픈', value: '가맹점 오픈'},
  {text: '마케팅팀', value: '마케팅팀'},
  {text: '가맹관리팀', value: '가맹관리팀'},
  {text: '아카데미 교육팀', value: '아카데미 교육팀)'},
  {text: '해외 매장 파견', value: '해외 매장 파견'},
  {text: '기타', value: '기타'},
];

const familyRelationsOptionItems = [
  {text: '부', value: '부'},
  {text: '모', value: '모'},
  {text: '기타', value: '기타'},
];

export {
  graduateOptionItems,
  hopeAreaOptionItems,
  hopePathOptionItems,
  familyRelationsOptionItems,
};